module.exports = __webpack_public_path__ + "img/globe-icon.c2f0887b.svg";